<template>
  <div class="breadcrumbs">
    <ol class="breadcrumbs__list" itemscope itemtype="https://schema.org/BreadcrumbList">
      <li
        v-for="(crumb, index) in mainCrumbs"
        :key="`${crumb.title + 1}`"
        class="breadcrumbs__item"
        itemscope
        itemprop="itemListElement"
        itemtype="https://schema.org/ListItem"
      >
        <app-link
          :href="crumb.link"
          :class="{ _white: isWhiteColor }"
          class="breadcrumbs__link"
          itemprop="item"
        >
          <span itemprop="name">
            {{ crumb.title }}
          </span>
        </app-link>
        <meta itemprop="position" :content="index + 1" />
      </li>
      <li
        v-if="lastCrumb"
        class="breadcrumbs__item _last-item"
        itemscope
        itemprop="itemListElement"
        itemtype="https://schema.org/ListItem"
      >
        <span
          :class="{ _white: isWhiteColor }"
          itemprop="name"
        >
          {{ lastCrumb.title }}
        </span>
        <meta itemprop="position" :content="crumbs.length" />
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumbs',
  props: {
    crumbs: {
      type: Array,
      required: true,
    },
    isWhiteColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mainCrumbs() {
      return this.crumbs.slice(0, -1);
    },
    lastCrumb() {
      if (!this.crumbs.length) return null;
      return this.crumbs[this.crumbs.length - 1];
    },
  },
};
</script>

<style lang="less">
.breadcrumbs {
  &__list {
    .list-reset;

    display: flex;
    position: relative;
    overflow: hidden;
    padding: 0;
    list-style: none;
    min-height: 24px;
  }

  &__item {
    .small;

    margin-right: 19px;
    white-space: nowrap;

    &._last-item {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      color: @gray-dark;

      &::before,
      &::after {
        display: none;
      }
    }
  }

  &__link {
    .a-reset;
    .small;

    &._white {
      color: @white;
    }

    color: @gray-dark;
    position: relative;
    transition: @A color;
    display: block;

    &::before,
    &::after {
      pointer-events: none;
      content: '';
      position: absolute;
      top: 50%;
      right: -15px;
      width: 6px;
      height: 1px;
      background-color: currentColor;
      transition: @A background-color;
    }

    &::before {
      transform: rotate(-45deg) translate(-4px, 0);
    }

    &::after {
      transform: rotate(45deg) translate(-1px, -1px);
      right: -12px;
    }

    &:hover,
    &._tap {
      color: @link-visited;
    }

    &:active {
      color: @link;
    }
  }
}
</style>
